import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import { connect } from "formik";
import { compose } from "redux";
import _ from "lodash";

import { StyledDecimalInput, StyledAutoCompleteInput, StyledDatePicker } from "../styles";
import {
  CAP_VOLS
  , MARKET_EXPECTATIONS_SHOCK
  , PARALLEL_SHOCK
  , STANDARD_DEVIATION_SHOCK
  , SHOCKS
} from "../loanProceedsConstants";

function isMarketExpectationsSelected(shockType) {
  return !shockType || shockType === MARKET_EXPECTATIONS_SHOCK;
}

function shouldDisableShockValue(curve, shockType) {
  return (
    curve !== CAP_VOLS &&
    shockType === MARKET_EXPECTATIONS_SHOCK
  );
}

function getShockValueLabel(shockType) {
  if (shockType === PARALLEL_SHOCK) {
    return "Parallel Shift Amt (bp)";
  }
  if (shockType === STANDARD_DEVIATION_SHOCK) {
    return "Standard Deviations";
  }

  return "";
}

const RateEnvironmentSection = props => {
  const { formik } = props;
  const { values, handleChange, setFieldValue } = formik;
  const shouldHideFloatingRate = false;
  const shouldHideShockValue = isMarketExpectationsSelected(values.shockType);

  return (
    <>
      <Grid item xs={3}>
        <StyledDatePicker
          label="Calculation Date"
          fieldName="calculationDate"
          onChange={e => {
            setFieldValue("calculationDate", e.toISOString());
            if (props.dealPropertyProjections) {
              const foundProjection = props.findProjectionValues(e);
              if (foundProjection) {
                const projectedNOI = { target: { name: "projectedNOI", value: foundProjection.noi } };
                handleChange(projectedNOI);
                const futureCapRate = { target: { name: "futureCapRate", value: foundProjection.capRate * 100 } };
                handleChange(futureCapRate);
              }
            }
          }}
        />
      </Grid>

      <Grid item xs={3} hidden={shouldHideFloatingRate}>
        <StyledAutoCompleteInput label="Shock Scenario" fieldName="shockType" selectValue="value" options={SHOCKS} />
      </Grid>
      <Grid item xs={3}>
        {(!shouldHideFloatingRate && !shouldHideShockValue) && <StyledDecimalInput calculateLabel={({ values }) => getShockValueLabel(values.shockType)} fieldName="shockValue" disabled={shouldDisableShockValue(values.curve, values.shockType)} />}
      </Grid>
    </>
  );
};
export default compose(
  connect
)(RateEnvironmentSection);
